import { useEffect, useState } from "react";
import api from "../lib/api";
import { ReelsFeed } from "../components/ReelsFeed";

const Discover = () => {
  const [genres, setGenres] = useState([]);
  const [genre, setGenre] = useState("All");
  const [videos, setVideos] = useState(null);

  useEffect(() => {
    api.get("/genres").then((r) => setGenres(["All", ...r.data]));
  }, []);

  useEffect(() => {
    setVideos(null);
    api.get(`/videos?genre=${encodeURIComponent(genre)}&sort=popular`).then((r) => setVideos(r.data)).catch(() => setVideos([]));
  }, [genre]);

  return (
    <div className="relative">
      {/* Genre chips overlay */}
      <div className="absolute top-0 left-0 right-0 z-30 bg-gradient-to-b from-black/80 to-transparent pt-3 pb-6">
        <div className="flex gap-2 overflow-x-auto no-scrollbar px-4">
          {genres.map((g) => (
            <button
              key={g}
              data-testid={`genre-chip-${g}`}
              onClick={() => setGenre(g)}
              className={`flex-shrink-0 px-4 py-1.5 rounded-full text-sm font-semibold transition-colors border ${
                genre === g ? "bg-[#FFD60A] text-black border-[#FFD60A]" : "bg-black/40 backdrop-blur-md border-white/15 text-white"
              }`}
            >
              {g}
            </button>
          ))}
        </div>
      </div>

      {videos === null ? (
        <div className="h-[calc(100vh-6.5rem)] flex items-center justify-center text-zinc-500">Loading…</div>
      ) : (
        <ReelsFeed key={genre} videos={videos} emptyText={`No ${genre} videos yet.`} />
      )}
    </div>
  );
};

export default Discover;
